module.exports = __webpack_public_path__ + "static/media/VattenfallHall-Regular.207f07db.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/VattenfallHallRegular/VattenfallHall-Regular.eot
// module id = 200
// module chunks = 0